import { AppConfig } from '@ltvco/refresh-lib/ctx';
import { SelectChangeEvent } from '@ltvco/refresh-lib/theme';
import { ExpandMore } from '@mui/icons-material';
import { useContext } from 'react';

import { MenuSelectOptionProps } from '../../interfaces';

import { StyledSelect } from './components';

export const MenuSelect = ({
  enabledMenuOptions,
  onChangeCallback,
  value,
  variant,
}: {
  enabledMenuOptions: { [key: string]: MenuSelectOptionProps };
  // eslint-disable-next-line no-unused-vars
  onChangeCallback: (option: MenuSelectOptionProps) => void;
  value: string;
  variant?: string;
}) => {
  const { trackEvent } = useContext(AppConfig);

  const localOnChangeCallback = (event: SelectChangeEvent) => {
    trackEvent(
      'dropdown menu',
      `engagement click ${event.target.value}`,
      'astrology'
    );
    onChangeCallback(
      enabledMenuOptions[event.target.value as keyof typeof enabledMenuOptions]
    );
  };
  return (
    <StyledSelect
      className={variant}
      id="astrology-menu-select"
      value={value}
      IconComponent={ExpandMore}
      options={Object.keys(enabledMenuOptions).map((optionKey: string) => {
        const option =
          enabledMenuOptions[optionKey as keyof typeof enabledMenuOptions];
        return { value: option.value, display: option.display };
      })}
      onChange={localOnChangeCallback}
    />
  );
};
